import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

import "./commonStyles/index.css";
import "./commonStyles/fontAndColors.css";
import "./commonStyles/print.css";

import sanitizeHtml from "sanitize-html";
import { BrowserRouter as Router } from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById("root"));

function onPaste(e) {
  var content;
  e.preventDefault();

  if (e.clipboardData) {
    content =
      e.clipboardData.getData("text/html") ||
      e.clipboardData.getData("text/plain");
    document.execCommand(
      "insertHtml",
      false,
      sanitizeHtml(content, { allowedTags: [] }).trim()
    );
    return false;
  }
}

document.addEventListener("paste", onPaste);

root.render(
  <React.StrictMode>
    <Router>
      <App />
    </Router>
  </React.StrictMode>
);
